var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortugal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.200195 12.6513C0.200195 17.8108 3.4567 22.2094 8.02621 23.9049L9.06974 12.6513L8.02621 1.39771C3.4567 3.09327 0.200195 7.49174 0.200195 12.6513Z",
    fill: "#6DA544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2004 12.6511C24.2004 6.02375 18.8277 0.651123 12.2004 0.651123C10.7325 0.651123 9.3264 0.91517 8.02637 1.39751V23.9047C9.3264 24.3871 10.7325 24.6511 12.2004 24.6511C18.8277 24.6511 24.2004 19.2785 24.2004 12.6511Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02643 16.8251C10.3316 16.8251 12.2003 14.9564 12.2003 12.6512C12.2003 10.346 10.3316 8.47729 8.02643 8.47729C5.72125 8.47729 3.85254 10.346 3.85254 12.6512C3.85254 14.9564 5.72125 16.8251 8.02643 16.8251Z",
    fill: "#FFDA44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67871 10.5642V13.1729C5.67871 14.4696 6.72984 15.5207 8.02654 15.5207C9.32324 15.5207 10.3744 14.4696 10.3744 13.1729V10.5642H5.67871Z",
    fill: "#D80027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02677 13.9555C7.59523 13.9555 7.24414 13.6044 7.24414 13.1728V12.1294H8.80934V13.1729C8.80934 13.6044 8.45825 13.9555 8.02677 13.9555Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortugal);
export default __webpack_public_path__ + "static/media/Portugal.1b504188e200a47f070b85e5983a0e5b.svg";
export { ForwardRef as ReactComponent };